
import { defineComponent, ref } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { reactive } from 'vue';
import {
  get_project_set_item_detail,
  get_project_set_by_id,
  create_set_record,
  get_customer_wallet_fl_rate,
} from '@/api/mjstore-model';
import { notification } from 'ant-design-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { event_obj } from '@/components/page-model/mjstore/mjstore-orderrecord-config';
import { useForm } from 'ant-design-vue/es/form';
import moment from 'moment';
export default defineComponent({
  name: 'Setrecordmodel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    obj: {
      type: Object,
      required: true,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    const loading = ref(false);
    const card_ids: Array<number> = reactive([]);
    const project_ids: Array<number> = reactive([]);
    const formModel: any = reactive({
      card_ids: card_ids,
      project_ids: project_ids,
      is_active: true,
      // order_code: null,
      customer_id: null,
      project_set_id: '',
      // price: null,
      czje: null,
      flje: null,
      zjfl: 0,
      zjje: 0,
      date: moment().format('YYYY-MM-DD HH:mm:ss'),
      cxzc_id: null,
      shop_id: current_shop?.id,
      staff_id: null,
      num: 1,
      ...props.obj,
    });
    const rules = {
      customer_id: [{ required: true, message: '请填输入会员姓名' }],
      project_set_id: [{ required: true, message: '请填输入套餐名称' }],
      date: [
        { required: true, message: '请填输入下单时间' },
        {
          validator: async (rule: any, value: string) => {
            if (moment(value) > moment()) {
              return Promise.reject('不能选择大于当前日期的时间');
            } else {
              return Promise.resolve();
            }
          },
          trigger: 'change',
        },
      ],
      shop_id: [{ required: true, message: '请填输入执行门店' }],
      czje: [{ required: true, message: '请填写充值使用金额' }],
      flje: [{ required: true, message: '请填写返利使用金额' }],
      zjfl: [{ required: true, message: '请填写直接返利' }],
      zjje: [{ required: true, message: '请填写赠券使用金额' }],
      cxzc_id: [{ required: true, message: '请选择促销政策' }],
      staff_id: [{ required: true, message: '请选择执行人' }],
    };
    if (props.obj.customer_id > 0) {
      get_customer_wallet_fl_rate({
        org_id: current_org.id,
        customer_id: Number(props.obj.customer_id),
      }).then((res: any) => {
        formModel.fl_rate = res.fl_rate;
        formModel.cz_rate = 1 - res.fl_rate;
      });
    }
    const rulesRef = reactive({ ...rules });
    const { validate, validateInfos } = useForm(formModel, rulesRef);
    const modifyModal = {
      title: '套餐下单',
      form: {
        settings: {
          labelAlign: 'right',
          layout: 'horizontal',
          labelCol: {
            span: 8,
          },
          wrapperCol: {
            span: 16,
          },
        },
        fields: [
          {
            type: 'remotemodal',
            name: 'customer_id',
            label: '会员姓名',
            disabled: !!props.obj.disabled,
            placeholder: '请选择会员姓名',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-customer',
          },
          {
            type: 'remotemodal',
            name: 'project_set_id',
            label: '套餐名称',
            disabled: false,
            placeholder: '请选择套餐名称',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-projectset',
          },
          {
            type: 'number',
            name: 'num',
            label: '套餐次数',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写套餐次数',
          },
          {
            type: 'input',
            name: 'price',
            label: '套餐单价',
            disabled: true,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写金额',
          },
          {
            type: 'input',
            name: 'sum_price',
            label: '总金额',
            disabled: true,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写金额',
          },
          {
            type: 'number',
            name: 'czje',
            label: '充值使用金额',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            placeholder: '请填写充值使用金额',
          },
          {
            type: 'number',
            name: 'flje',
            label: '返利使用金额',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            placeholder: '请填写返利使用金额',
          },
          {
            type: 'number',
            name: 'zjfl',
            label: '直接返利',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            placeholder: '请填写直接返利',
          },
          {
            type: 'number',
            name: 'zjje',
            label: '赠券使用金额',
            disabled: false,
            allowClear: true,
            placeholder: '请填写赠券使用金额',
          },
          {
            type: 'datepicker',
            name: 'date',
            label: '下套餐日期',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            format: 'YYYY-MM-DD HH:mm',
            valueFormat: 'YYYY-MM-DD HH:mm',
            showTime: true,
            placeholder: '请选择下套餐日期',
          },
          {
            type: 'remoteselect',
            name: 'cxzc_id',
            label: '促销政策',
            disabled: false,
            placeholder: '请选择促销政策',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-policy',
          },
          {
            type: 'remoteselect',
            name: 'shop_id',
            label: '执行门店',
            disabled: !!current_shop,
            placeholder: '请选择执行门店',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-shop',
          },
          {
            type: 'remoteselect',
            name: 'staff_id',
            label: '执行人',
            disabled: false,
            placeholder: '请选择执行人',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-staff',
          },
        ],
        rules: rules,
        model: formModel,
        watch: {
          project_set_id: (data: any) => {
            if (data['project_set_id'] > 0) {
              get_project_set_by_id({
                org_id: current_org.id,
                project_set_id: Number(data['project_set_id']),
              }).then((res: any) => {
                data['price'] = res.price;
                data['czje'] = (
                  (data['price'] * data['num'] - data['zjfl'] - data['zjje']) *
                  data['cz_rate']
                ).toFixed(0);
                data['flje'] =
                  data['price'] * data['num'] - data['zjfl'] - data['zjje'] - data['czje'];
              });
              get_project_set_item_detail({
                org_id: current_org.id,
                project_set_id: Number(data['project_set_id']),
              }).then((res: any) => {
                Object.assign(formModel, res);
                state.card.dataSource.length = 0;
                state.project.dataSource.length = 0;
                res.card_item.map((item: any, index: any) => {
                  item.unique_key = new Date().getTime() + index;
                  if (item.card_id == 11) {
                    item.num = item.month_num;
                  } else {
                    item.num = item.project_set_num;
                  }
                  state.card.dataSource.push(item);
                });
                res.item.map((item: any, index: any) => {
                  item.unique_key = new Date().getTime() + index;
                  item.num = item.project_set_num;
                  state.project.dataSource.push(item);
                });
              });
            }
          },
          num: (data: any) => {
            if (Number(data['price']) >= 0) {
              data['sum_price'] = Number(data['num']) * Number(data['price']);
            }
            data['czje'] = (
              (data['price'] * data['num'] - data['zjfl'] - data['zjje']) *
              data['cz_rate']
            ).toFixed(0);
            data['flje'] = data['price'] * data['num'] - data['zjfl'] - data['zjje'] - data['czje'];
          },
          price: (data: any) => {
            if (Number(data['price']) >= 0) {
              data['sum_price'] = Number(data['num']) * Number(data['price']);
            }
          },
          zjfl: (data: any) => {
            data['czje'] = (
              (data['price'] * data['num'] - data['zjfl'] - data['zjje']) *
              data['cz_rate']
            ).toFixed(0);
            data['flje'] = data['price'] * data['num'] - data['zjfl'] - data['zjje'] - data['czje'];
          },
          zjje: (data: any) => {
            data['czje'] = (
              (data['price'] * data['num'] - data['zjfl'] - data['zjje']) *
              data['cz_rate']
            ).toFixed(0);
            data['flje'] = data['price'] * data['num'] - data['zjfl'] - data['zjje'] - data['czje'];
          },
          customer_id: (data: any) => {
            get_customer_wallet_fl_rate({
              org_id: current_org.id,
              customer_id: Number(data.customer_id),
            }).then((res: any) => {
              data['cz_rate'] = 1 - res.fl_rate;
            });
          },
        },
      },
      validateInfos: validateInfos,
      options: {},
    };

    const cardDataSource: Array<any> = reactive([]);
    const projectDataSource: Array<any> = reactive([]);
    const state = {
      card: {
        columns: [
          {
            title: '卡名称',
            dataIndex: 'name',
            key: 'name',
            width: '50%',
            slots: { customRender: 'name' },
          },
          {
            title: '编号',
            dataIndex: 'code',
            key: 'code',
            width: '60%',
            slots: { customRender: 'code' },
          },
          {
            title: '价格',
            dataIndex: 'price',
            key: 'price',
            width: '50%',
            slots: { customRender: 'price' },
          },
          {
            title: '类型',
            dataIndex: 'card_type',
            key: 'card_type',
            width: '50%',
            slots: { customRender: 'card_type' },
          },
          {
            title: '数量',
            dataIndex: 'num',
            key: 'num',
            width: '50%',
            slots: { customRender: 'num' },
          },
          // {
          //   title: '操作',
          //   width: 100,
          //   dataIndex: 'action',
          //   slots: { customRender: 'action' },
          // },
        ],
        dataSource: cardDataSource,
      },
      project: {
        columns: [
          {
            title: '单名称',
            dataIndex: 'name',
            key: 'name',
            width: '50%',
          },
          {
            title: '编号',
            dataIndex: 'code',
            key: 'code',
            width: '60%',
            slots: { customRender: 'code' },
          },
          {
            title: '价格',
            dataIndex: 'price',
            key: 'price',
            width: '50%',
            slots: { customRender: 'price' },
          },
          {
            title: '类型',
            dataIndex: 'project_type__p_type',
            key: 'project_type__p_type',
            width: '50%',
            slots: { customRender: 'project_type__p_type' },
          },
          {
            title: '数量',
            dataIndex: 'num',
            key: 'num',
            width: '50%',
            slots: { customRender: 'num' },
          },
          // {
          //   title: '操作',
          //   width: 100,
          //   dataIndex: 'action',
          //   slots: { customRender: 'action' },
          // },
        ],
        dataSource: projectDataSource,
      },
    };
    const handleCancel = () => {
      emit('cancel');
    };
    const handleOk = () => {
      const p = new Promise(function (resolve) {
        validate()
          .then(() => {
            if (
              Number(formModel.czje) +
                Number(formModel.flje) +
                Number(formModel.zjfl) +
                Number(formModel.zjje) !=
              Number(formModel.price) * Number(formModel.num)
            ) {
              notification.error({
                message: '金额输入错误',
                description:
                  '下单金额应等于【充值使用金额】+【下单返利金额】+【直接返利金额】+【赠券使用金额】',
              });
              return false;
            }
            loading.value = true;
            const item_list: any[] = [];
            const card_item_list: any[] = [];
            state.card.dataSource.forEach((item: any) => {
              card_item_list.push({ id: item.id, num: item.num });
            });
            state.project.dataSource.forEach((item: any) => {
              item_list.push({ id: item.id, num: item.num });
            });
            create_set_record({
              org_id: current_org.id,
              ...formModel,
              item_json: JSON.stringify(item_list),
              card_item_json: JSON.stringify(card_item_list),
            })
              .then((res: any) => {
                if (res.is_confirm) {
                  Modal.confirm({
                    title: '提示',
                    content: res.message,
                    onOk() {
                      create_set_record({
                        org_id: current_org.id,
                        ...formModel,
                        item_json: JSON.stringify(item_list),
                        card_item_json: JSON.stringify(card_item_list),
                        is_confirm: true,
                      }).then(function () {
                        message.success('创建成功');
                        emit('ok');
                        event_obj.emit('refresh');
                        resolve(null);
                        loading.value = false;
                      });
                    },
                    onCancel() {
                      loading.value = false;
                    },
                  });
                } else {
                  notification.success({
                    message: '成功',
                    description: '购买套餐成功',
                  });
                  emit('ok');
                  event_obj.emit('refresh');
                  loading.value = false;
                }
              })
              .finally(() => {
                loading.value = false;
              });
          })
          .finally(() => {})
          .catch(err => {
            console.log('error', err);
          });
      });
      return p;
    };
    return {
      // fullscreen
      message,
      // edit
      loading,
      state,
      modifyModal,
      handleCancel,
      handleOk,
    };
  },
});
